export const formatDescription = (text: string) => {
    if (!text) return '';

    const sentences = text
        .split(/(?<=[.?!])\s+/)
        .filter(Boolean);

    const paragraphs: string[] = [];

    for (let i = 0; i < sentences.length; i += 3) {
        const group = sentences.slice(i, i + 3).join(' ');
        paragraphs.push(`<p>${group}</p>`);
    }

    return paragraphs.join('');
};

